import { Component, forwardRef, Input, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import * as differenceInCalendarDays_ from "date-fns/difference_in_calendar_days";
import { FieldType, KreFormCommonService } from "@kre-form/core";
import * as moment_ from "moment";
const moment = moment_;
const differenceInCalendarDays = differenceInCalendarDays_;

const FORM_POSITION_PICKER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DatetimeComponent),
  multi: true,
};
@Component({
  selector: "demo-datetime",
  templateUrl: "./datetime.component.html",
  styleUrls: ["./datetime.component.scss"],
  providers: [FORM_POSITION_PICKER_VALUE_ACCESSOR],
})
export class DatetimeComponent implements ControlValueAccessor, OnInit {
  _value: string = "";
  _index: number = 0;

  disabled: boolean = false;
  @Input() type: string = "datetime";
  @Input() maxDate: string = "";
  @Input() minDate: string = "";

  constructor() {}

  writeValue(value: any) {
    this._value = value;
  }
  _onTouched: any = () => {};
  _valueChange: any = () => {};
  registerOnChange(fn: any) {
    this._valueChange = fn;
  }
  registerOnTouched(fn: any) {
    this._onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  select(color: string) {
    if (this.disabled) {
      return;
    }
    this._value = color;
    this._valueChange(color);
  }

  ngOnInit() {}
  disabledDate = (current: Date): boolean => {
    if (!!this.maxDate && !!this.minDate) {
      return (
        differenceInCalendarDays(current, new Date(this.maxDate)) > 0 ||
        differenceInCalendarDays(current, new Date(this.minDate!)) < 0
      );
    } else if (!!this.maxDate && !this.minDate) {
      return differenceInCalendarDays(current, new Date(this.maxDate)) > 0;
    } else if (!this.maxDate && !!this.minDate) {
      return differenceInCalendarDays(current, new Date(this.minDate)) < 0;
    } else {
      return false;
    }
  };

  disabledDateTime = (e: Date) => {
    let nzDisabledHours: number[] = [];
    let nzDisabledMinutes: number[] = [];

    if (!!this.maxDate && !!this.minDate) {
      if (differenceInCalendarDays(e, new Date(this.minDate)) === 0) {
        nzDisabledHours = this.range(-1, new Date(this.minDate).getHours());

        if (!!e && new Date(this.minDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = this.range(
            -1,
            new Date(this.minDate).getMinutes()
          );
        }
      }
      if (differenceInCalendarDays(e, new Date(this.maxDate)) === 0) {
        nzDisabledHours = [
          ...nzDisabledHours,
          ...this.range(new Date(this.maxDate).getHours() + 1, 24),
        ];

        if (!!e && new Date(this.maxDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = [
            ...nzDisabledMinutes,
            ...this.range(new Date(this.maxDate).getMinutes(), 60),
          ];
        }
      }
    } else if (!!this.maxDate && !this.minDate) {
      if (!!e && differenceInCalendarDays(e, new Date(this.maxDate)) === 0) {
        nzDisabledHours = this.range(new Date(this.maxDate).getHours() + 1, 24);
        if (!!e && new Date(this.maxDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = this.range(
            new Date(this.maxDate).getMinutes(),
            60
          );
        }
      }
    } else if (!this.maxDate && !!this.minDate) {
      if (!!e && differenceInCalendarDays(e, new Date(this.minDate)) === 0) {
        nzDisabledHours = this.range(0, new Date(this.minDate).getHours());
        if (!!e && new Date(this.minDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = this.range(
            -1,
            new Date(this.minDate).getMinutes()
          );
        }
      }
    }
    return {
      nzDisabledHours: () => nzDisabledHours,
      nzDisabledMinutes: () => nzDisabledMinutes,
      nzDisabledSeconds: () => [],
    };
  };

  disabledHours = () => {
    let nzDisabledHours: number[] = [];

    if (!!this.maxDate && !!this.minDate) {
      nzDisabledHours = this.range(-1, new Date(this.minDate).getHours());
      nzDisabledHours = nzDisabledHours.concat(
        this.range(new Date(this.maxDate).getHours() + 1, 24)
      );
    } else if (!!this.maxDate && !this.minDate) {
      nzDisabledHours = this.range(new Date(this.maxDate).getHours() + 1, 24);
    } else if (!this.maxDate && !!this.minDate) {
      nzDisabledHours = this.range(0, new Date(this.minDate).getHours());
    }
    return nzDisabledHours;
  };

  disabledMinutes = (e: Date) => {
    let nzDisabledMinutes: number[] = [];
    if (!!this.maxDate && !!this.minDate) {
      if (differenceInCalendarDays(e, new Date(this.minDate)) === 0) {
        if (!!e && new Date(this.minDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = this.range(
            -1,
            new Date(this.minDate).getMinutes()
          );
        }
      }
      if (differenceInCalendarDays(e, new Date(this.maxDate)) === 0) {
        if (!!e && new Date(this.maxDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = this.range(
            new Date(this.maxDate).getMinutes(),
            60
          );
        }
      }
    } else if (!!this.maxDate && !this.minDate) {
      if (!!e && differenceInCalendarDays(e, new Date(this.maxDate)) === 0) {
        if (!!e && new Date(this.maxDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = this.range(
            new Date(this.maxDate).getMinutes(),
            60
          );
        }
      }
    } else if (!this.maxDate && !!this.minDate) {
      if (!!e && differenceInCalendarDays(e, new Date(this.minDate)) === 0) {
        if (!!e && new Date(this.minDate).getHours() - e.getHours() === 0) {
          nzDisabledMinutes = this.range(
            -1,
            new Date(this.minDate).getMinutes()
          );
        }
      }
    }

    return nzDisabledMinutes;
  };
  // differenceInCalendarDays(e: Date | null, date: Date): number {
  //   if (!!e) {
  //     return e.getDate() - date.getDate();
  //   } else {
  //     return 0;
  //   }
  // }

  range(start: number, end: number): number[] {
    const result: number[] = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }
}
